import { Phone, Mail, MapPin, Clock } from "lucide-react";

const cards = [
  {
    icon: Phone,
    title: "Phone",
    lines: ["(832) 661-1121"],
    href: "tel:+18326611121",
    testid: "contact-phone",
  },
  {
    icon: Mail,
    title: "Email",
    lines: ["clovis1200@yahoo.com"],
    href: "mailto:clovis1200@yahoo.com",
    testid: "contact-email",
  },
  {
    icon: MapPin,
    title: "Service Area",
    lines: ["Greater Houston & Surrounding Areas", "Harris, Fort Bend, Montgomery, Brazoria, Galveston counties"],
    testid: "contact-area",
  },
  {
    icon: Clock,
    title: "Business Hours",
    lines: ["Mon – Fri: 6:00 AM – 5:00 PM", "Sat: 8:00 AM – 12:00 PM", "Sun: Closed"],
    testid: "contact-hours",
  },
];

export default function Contact() {
  return (
    <section id="contact" className="relative py-24 lg:py-32 noise-overlay" data-testid="contact-section">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: "url(/assets/contact-bg.webp)",
        }}
        aria-hidden="true"
      />
      <div className="absolute inset-0 bg-[#0F172A]/90" aria-hidden="true" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A00] mb-4 font-mono-tech" data-testid="contact-overline">
            Contact Us • 09
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-white" data-testid="contact-heading">
            Let's Talk About Your Project
          </h2>
          <p className="mt-6 text-base text-slate-300 leading-relaxed">
            Serving engineering firms, contractors, developers, and municipalities throughout Greater Houston.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6" data-testid="contact-grid">
          {cards.map((c) => {
            const inner = (
              <>
                <c.icon className="w-8 h-8 text-[#FF5A00]" />
                <h3 className="mt-5 font-heading text-base font-bold uppercase tracking-wider text-white">{c.title}</h3>
                {c.lines.map((l) => (
                  <p key={l} className="mt-2 text-sm text-slate-300 leading-relaxed">{l}</p>
                ))}
              </>
            );
            const cls =
              "bg-white/5 backdrop-blur-sm border border-white/10 rounded-sm p-8 transition-all duration-200 hover:-translate-y-1 hover:border-[#FF5A00]";
            return c.href ? (
              <a key={c.title} href={c.href} className={cls} data-testid={c.testid}>
                {inner}
              </a>
            ) : (
              <div key={c.title} className={cls} data-testid={c.testid}>
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
